module.exports = __webpack_public_path__ + "static/media/match.890009bc.svg";